import React from "react";
import { Container, Title } from "./style";
export default function Footer() {
  return (
    <Container>
      <Title title>Sardorbek Kholdarboev</Title>
      <Title desc>Copyright &copy; 2022 All Rights Reserved</Title>
    </Container>
  );
}
